import { FileText } from "lucide-react";
import { theme } from "../../../theme";

type ProviderToolbarProps = {
  showSources: boolean;
  onShowSourcesChange: (show: boolean) => void;
};

export const ProviderToolbar = ({
  showSources,
  onShowSourcesChange,
}: ProviderToolbarProps) => {
  return (
    <div className="flex items-center gap-2 px-4 py-2 border-b dark:border-white/[0.06] border-black/[0.06]">
      <button
        onClick={() => onShowSourcesChange(!showSources)}
        aria-label={showSources ? "Hide sources" : "Show sources"}
        aria-pressed={showSources}
        className={`${theme.providerToggle.base} ml-auto ${
          showSources
            ? "dark:bg-teal-500/[0.12] dark:border-teal-500/[0.25] dark:text-teal-400 bg-teal-50 border border-teal-200 text-teal-700"
            : theme.providerToggle.inactive
        }`}
      >
        <FileText className="w-3 h-3" />
        Sources
      </button>
    </div>
  );
};
